import React, { useState, useEffect } from "react";
import axios from "axios";
import { message } from "antd";

import PageHeader from "../../Routes/PageHeader";
import FormModal from "./FormModal";
import DataTable from "./DataTable";
import { API, Headers } from "../../Config";
import LoadingBox from "../../Components/LoadingBox";

function CustomerScreen() {
  const [loading, setLoading] = useState(true);
  const [form, setform] = useState(false);
  const [mode, setMode] = useState("post");
  const [item, setItem] = useState({});
  const [data, setData] = useState([]);
  const [indicator, setIndicator] = useState(false);
  const [meta, setMeta] = useState({});
  const [users, setusers] = useState([]);
  useEffect(() => {
    UsersDropdown();
    loaddata();
  }, []);
  const UsersDropdown = () => {
    axios
      .get(API.BASR_URL + API.USERS_LIST + `/list`, {
        headers: Headers(),
      })
      .then(function (res) {
        if (res.status === 200) setusers(res.data);
      })
      .catch(function (error) {
        message.error("users dropdown faild");
      });
  };
  const loaddata = () => {
    axios
      .get(API.BASR_URL + API.CUSTOMERS_LIST, {
        headers: Headers(),
        params: {
          order: "ASC",
          page: 1,
          take: 10,
        },
      })
      .then(function (response) {
        setLoading(false);
        if (response.status === 200) {
          let data = response.data;
          setData(data.data);
          setMeta(data.meta);
          message.success("Success");
        } else {
          message.error("Oops.Something went wrong");
        }
        setLoading(false);
        setIndicator(false);
      })
      .catch(function (error) {
        message.error("Oops.Something went wrong");
        setLoading(false);
      });
  };

  const relaod = () => {
    loaddata();
    setMode("post");
    setItem({});
    setform(false);
  };

  const AddItem = () => {
    setMode("post");
    setItem({});
    setform(true);
  };

  const UpdateItem = (item) => {
    setMode("put");
    setItem(item);
    setform(true);
  };

  const DeleteItem = (item) => {
    setIndicator(true);
    axios
      .delete(API.BASR_URL + API.CUSTOMERS_ACTION + item.id, {
        headers: Headers(),
      })
      .then(function (response) {
        setIndicator(false);
        message.success("Deleted Successfully");
        relaod();
      })
      .catch(function (error) {
        setIndicator(false);
        message.error("Oops.Something went wrong");
        console.log(error);
      });
  };

  return (
    <div>
      <PageHeader
        PageName={"Customers"}
        breadScrum={"Admin / Customers"}
        RightButton={"New Customer "}
        RightClcik={() => AddItem()}
        loader={indicator}
      />
      {loading ? (
        <LoadingBox />
      ) : (
        <div>
          <DataTable
            meta={meta}
            data={data}
            update={(item) => UpdateItem(item)}
            delete={(item) => DeleteItem(item)}
            PageOnchange={(item) => console.log("PageOnchange", item)}
          />
          {form ? (
            <FormModal
              item={item}
              mode={mode}
              users={users}
              visible={form}
              onchange={() => relaod()}
              onClose={() => setform(false)}
            />
          ) : null}
        </div>
      )}
    </div>
  );
}
export default CustomerScreen;
